import { GridRowSelectionModel } from '@mui/x-data-grid-pro'
import { createContext } from 'react'
import { SubcontractorRequestStatus } from 'src/constants/subcontractorRequests/enum'
import { LinkedSubcontractor } from 'src/interfaces/subcontractor'

export interface ILinkSubcontractorTableContext {
  statusFilter: Array<SubcontractorRequestStatus>
  setStatusFilter(statusFilter: Array<SubcontractorRequestStatus>): void

  tagsFilter: Array<string>
  setTagsFilter(statusFilter: Array<string>): void

  actionAnchor: null | HTMLElement
  contractorToAction: LinkedSubcontractor | null
  openLinkSubcontractorItemToAction(
    event: React.MouseEvent<HTMLButtonElement>,
    contractor: LinkedSubcontractor,
  ): void
  closeLinkSubcontractorItemToAction(): void
  clearLinkSubcontractorItemToAction(): void

  selectedContractorIds: GridRowSelectionModel
}

export const LinkSubcontractorTableContext = createContext<ILinkSubcontractorTableContext>({
  statusFilter: [],
  setStatusFilter: () => {},

  tagsFilter: [],
  setTagsFilter: () => {},

  actionAnchor: null,
  contractorToAction: null,
  openLinkSubcontractorItemToAction: () => {},
  closeLinkSubcontractorItemToAction: () => {},
  clearLinkSubcontractorItemToAction: () => {},

  selectedContractorIds: [],
})
